import React from 'react'
import { Link } from 'react-router-dom'

import img1 from "../../assets/hiw-1.jpeg"
import img2 from "../../assets/hiw-2.jpeg"
import img3 from "../../assets/hiw-3.jpeg"
import img4 from "../../assets/hiw-4.jpeg"
import img5 from "../../assets/hiw-5.jpeg"

const HowItWorks = () => {
    const data = [
        {
            id: 1,
            name: 'Purchase AR-QR codes ',
            description: <p className='text-lg'>
                View Our <Link className='font-semibold underline' to={"https://interactive-images.eventshop.com/case-studies"}>Inspiration</Link> page to get an idea of what products work with well with our codes. If you are using our codes for posters, hardcover books, trading cards or laminates we can manufacture the items & ship to your address.
            </p>,
            img: img1
        },
        {
            id: 2,
            name: 'Upload content to create an experience that can only be viewed with our codes.',
            description: <p className='text-lg'>
                This is the exclusive content fans will see when they scan the AR-QR code that will be placed on the physical item. Video content plays in Augmented Reality directly on the physical item and cannot be screen recorded, saved on a device or shared online.
            </p>,
            img: img2
        },
        {
            id: 3,
            name: 'Set Your Content Availability Dates',
            description: <p className='text-lg'>
                Uploaded content can be active using our codes for as long as 5 years and as short as 1 hour. For custom projects, content can also be geofenced as well as have different content play based on location. Multiple videos can be uploaded as well and set to play on certain dates and times or randomized.
            </p>,
            img: img3
        },
        {
            id: 4,
            name: 'Change your content anytime even after the AR-QR codes are printed.',
            description: <p className='text-lg'>
                Your code is now ready to download and be applied to your physical item. You can stylize and blend your code to match the colors and unique shape of your item as well. If we are not printing your physical product your code is downloadable as a .png file. Keep in mind we also can create custom apps or integrate into your mobile app. In this scenario our technology works via image recognition (which means you do not need an AR-QR code)
            </p>,
            img: img4
        },
        {
            id: 5,
            name: 'Update your content whenever you like',
            description: <p className='text-lg'>
                Simply log into your CMS Dashboard to change the video, audio or call to action links at any time during the code activation period. It takes 3-5 minutes for the content to change on the code when updated in your CMS dashboard.
            </p>,
            img: img5
        },
    ]
    return (
        <div className='how-it-works py-[50px]'>
            <div className="max-w-6xl mx-auto">
                <h1 className='text-center text-[40px] lg:text-[60px] font-bold'>
                    How It Works
                </h1>
                <p className='mt-4 text-lg text-center'>
                Each AR-QR code unlocks a video, audio file, or Call to Action link. <br /> Purchase codes and input your digital content via our CMS Dashboard.
                </p>

                <div className="mt-[50px]">
                    {
                        data.map(item => (
                            <div key={item.id} className='flex lg:flex-row flex-col-reverse justify-between items-start gap-10 lg:gap-20 mt-14'>
                                <div className="left w-full lg:w-[50%] p-5 bg-white shadow-xl rounded-md">
                                    <img src={item.img} className='w-full' alt="" />
                                </div>
                                <div className="right w-full lg:w-[50%]">
                                    <h2 className='besley text-[25px] lg:text-[30px] font-normal italic mb-3'>{item.id}</h2>
                                    <h3 className='text-[30px] font-semibold'>{item.name}</h3>
                                    <p className='text-lg mt-4'>{item.description}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default HowItWorks
